/*!
 *  2019-3-4 17:56:04
 *  Copyright 2019 FT, DK Techin Corp 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _app = __webpack_require__(9);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _log = __webpack_require__(41);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var collection = window.C.imageColl;
	var imageModel = collection.items;
	var collMeta = collection.meta;
	
	var $imageColl = (0, _jquery2['default'])('#' + collMeta.wrapCollId);
	
	var imageApp = new _app2['default']($imageColl, {
	  data: imageModel,
	  buttonExtendSelector: '#imgExtendView',
	  thumbBoard: {
	    areaWrapper: '.mg_cont',
	    board: '#imgList',
	    fixedImageDivWidth: 68,
	    fixedImageDivHeight: 90
	  }
	});
	
	resetBoardHeight(imageApp);
	toggleLoadingStateOnAjaxRequestStatusChange(imageApp);
	imageApp.$app.on('render', function () {
	  showEvenThumbs(imageApp);
	});
	showMoreImagesOnButtonClick(imageApp);
	(0, _log2['default'])($imageColl, imageApp);
	
	/**
	 * log
	 * update tenth-2-plugin
	 *
	 */
	
	function showMoreImagesOnButtonClick(imageApp) {
	  var maxClickCnt = 3;
	  var disabled = false;
	  imageApp.btnExtend.$elem.on('click', function () {
	    if (disabled) {
	      return;
	    }
	    disabled = true;
	    var appState = imageApp.state;
	    var clickCnt = appState.moreBtnClickCnt;
	
	    if (clickCnt < maxClickCnt) {
	      appState.moreBtnClickCnt = appState.moreBtnClickCnt + 1;
	    } else {
	      appState.moreBtnClickCnt = 0;
	      changeViewByActionType('extend');
	    }
	
	    if (appState.visibleLine === 8) {
	      appState.visibleLine = 0;
	      window.scrollTo(0, $imageColl.offset().top);
	    }
	    appState.reachedAjaxCallLimit = clickCnt === maxClickCnt;
	
	    if (imageApp.thumbBoard.thumbnails.length >= 80 || appState.reachedAjaxCallLimit) {
	      showEvenThumbs(imageApp);
	      disabled = false;
	      setButtonViewByClickCount(appState.moreBtnClickCnt, maxClickCnt);
	      return;
	    }
	
	    imageApp.getMoreData({
	      m: 'img',
	      req: 'qtotal',
	      cnucc: imageApp.state.isUserReportMode ? 1 : null,
	      sd: SF.urlParameter.sd || null,
	      ed: SF.urlParameter.ed || null,
	      lpp: imageApp.thumbBoard.thumbnails.length,
	      page: appState.dataPageNum + 1
	    }).always(function () {
	      disabled = false;
	      setButtonViewByClickCount(appState.moreBtnClickCnt, maxClickCnt);
	    });
	  });
	}
	
	function resetBoardHeight(imageApp) {
	  imageApp.thumbBoard.$board.height('auto');
	}
	
	function changeViewByActionType(actionType) {
	  var $extendView = imageApp.btnExtend.$elem;
	  var $textWrapper = $extendView.find('span').eq(0);
	  switch (actionType) {
	    case 'loading':
	      $textWrapper.removeClass('inner').text('로딩중...');
	      break;
	    case 'loading_success':
	      $textWrapper.addClass('inner').text('펼쳐보기');
	      break;
	    case 'extend':
	      $extendView.addClass('open').removeClass('close');
	      break;
	    case 'collapse':
	      $extendView.addClass('close').removeClass('open');
	      break;
	    default:
	  }
	}
	
	function showEvenThumbs(imageApp) {
	  var appState = imageApp.state;
	  var thumbnails = imageApp.thumbBoard.thumbnails;
	  var lineCnt = appState.visibleLine + 2;
	
	  var showThumbnailsBelowLineCnt = function showThumbnailsBelowLineCnt(idx, each) {
	    each.data.hide = each.data.lineCount <= lineCnt ? 'N' : 'Y';
	  };
	  var setDisplayByLineCnt = function setDisplayByLineCnt(idx, each) {
	    each.data.hide === 'Y' ? each.$html.hide() : each.$html.show();
	  };
	
	  _jquery2['default'].each(thumbnails, showThumbnailsBelowLineCnt);
	  _jquery2['default'].each(thumbnails, setDisplayByLineCnt);
	
	  appState.visibleLine += 2;
	}
	
	function setButtonViewByClickCount(cnt, maxClickCnt) {
	  if (cnt === 1) {
	    changeViewByActionType('extend');
	  } else if (cnt === maxClickCnt) {
	    changeViewByActionType('collapse');
	  }
	}
	
	function toggleLoadingStateOnAjaxRequestStatusChange(imageApp) {
	  imageApp.$app.on('load:start', function () {
	    changeViewByActionType('loading');
	  });
	
	  imageApp.$app.on('load:end', function () {
	    changeViewByActionType('loading_success');
	  });
	}

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.makeRequeryUrl = exports.memoize = exports.toRelativeProtocol = exports.inherit = exports.toParamString = exports.makeDateStr = exports.debounce = exports.toCssString = exports.toParamObj = exports.makeAjaxRequestUri = exports.httpsToHttp = exports.getCclHtml = undefined;
	exports.removeEmpty = removeEmpty;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _getCclHtml = __webpack_require__(20);
	
	var _getCclHtml2 = _interopRequireDefault(_getCclHtml);
	
	var _debounce = __webpack_require__(22);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _url = __webpack_require__(26);
	
	var _inherit = __webpack_require__(21);
	
	var _inherit2 = _interopRequireDefault(_inherit);
	
	var _memoize = __webpack_require__(25);
	
	var _memoize2 = _interopRequireDefault(_memoize);
	
	var _makeRequeryUrl = __webpack_require__(24);
	
	var _makeRequeryUrl2 = _interopRequireDefault(_makeRequeryUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function camelToHyphen(str) {
	  return str.replace(/([A-Z])/g, function (g) {
	    return '-' + g[0].toLowerCase();
	  });
	}
	
	function toCssString(obj) {
	  var arr = [];
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      arr.push(camelToHyphen(key) + ':' + obj[key]);
	    }
	  }
	  return arr.join(';');
	}
	
	/**
	 * makeDateStr
	 * 공통
	 * 날짜형태의 데이터를 yyyy.mm.dd 형태로 만들어서 반환하는 메소드
	 * @param date_str 원본날짜 문자열
	 * @returns String 변환된 문자열
	 */
	function makeDateStr(date_str) {
	  if (date_str.length >= 8) {
	    return _jquery2['default'].format.dateformat(date_str, 'yyyy.MM.dd');
	  } else {
	    return date_str;
	  }
	}
	
	function removeEmpty(obj) {
	  var newObj = {};
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key) && obj[key]) {
	      newObj[key] = obj[key];
	    }
	  }
	  return newObj;
	}
	
	exports.getCclHtml = _getCclHtml2['default'];
	exports.httpsToHttp = _url.httpsToHttp;
	exports.makeAjaxRequestUri = _url.makeAjaxRequestUri;
	exports.toParamObj = _url.toParamObj;
	exports.toCssString = toCssString;
	exports.debounce = _debounce2['default'];
	exports.makeDateStr = makeDateStr;
	exports.toParamString = _url.toParamString;
	exports.inherit = _inherit2['default'];
	exports.toRelativeProtocol = _url.toRelativeProtocol;
	exports.memoize = _memoize2['default'];
	exports.makeRequeryUrl = _makeRequeryUrl2['default'];

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var imageColl = exports.imageColl = window.C.imageColl || window.T.imageColl;
	var utf8Query = exports.utf8Query = imageColl.meta.UTF8Query;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _utils = __webpack_require__(2);
	
	var _globals = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// 클릭코드의 기본 값. pc/mo, tot/tab 별로 달라진다. 기본은 tab
	var basicCode = {
	  "s": "IM",
	  "a": "IMTO",
	  "dc": "IIM"
	};
	
	function sendClickLog(targetElem, params, event, extra) {
	  var isBasic = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	  var paramsMerged = isBasic ? _jquery2['default'].extend({}, basicCode, params) : _jquery2['default'].extend({}, params);
	  window.smartLog(targetElem, (0, _utils.toParamString)(paramsMerged), event, extra);
	}
	
	function sendFreeLog(paramArgs) {
	  var freeLogUrl = 'https:' + window.SEARCHLOGDOMAIN + '/fr/imgviewer/p?vle=';
	  var params = _jquery2['default'].extend({
	    rclk: 1,
	    q: _globals.utf8Query,
	    mk: window.mk || null,
	    ud: window.ud || null,
	    device: 'pc'
	  }, paramArgs);
	
	  var reqUrl = '' + freeLogUrl + encodeURIComponent((0, _utils.toParamString)(params));
	  _jquery2['default'].cachedScript(reqUrl);
	}
	
	function setBasicCode(key, value) {
	  basicCode[key] = value;
	}
	
	exports['default'] = {
	  sendClickLog: sendClickLog,
	  sendFreeLog: sendFreeLog,
	  setBasicCode: setBasicCode
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultParams = {
	  SortType: '',
	  sort: '',
	  ColorByName: '',
	  ColorGroup: '',
	  FaceType: '',
	  sd: '',
	  ed: '',
	  Size: '',
	  nvType: '',
	  period: '',
	  viewsite: '',
	  olpp: '',
	  page: '',
	  opage: '',
	  monochrome: '',
	  clipart: '',
	  lineart: '',
	  CclCommercial: '',
	  CclDerivative: ''
	};
	
	exports['default'] = _jquery2['default'].extend(defaultParams, SF.urlParameter);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Component(_ref) {
	  var template = _ref.template,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? {} : _ref$data;
	
	  this.data = data;
	  this.setTemplate(template);
	  this.eventTargets = [];
	  this.$html = null;
	}
	
	Component.prototype = {
	  addEventListener: function addEventListener(target, etype, callback) {
	    this.eventTargets.push({ target: target, callback: callback, etype: etype });
	    this.$html.on(etype, target, callback);
	  },
	  setTemplate: function setTemplate(jsrenderTemplateString) {
	    if (!jsrenderTemplateString) {
	      return;
	    }
	    this.template = _jquery2['default'].templates(jsrenderTemplateString);
	  },
	
	
	  /**
	   * 컴포넌트가 받은 데이터를 render 함수로 전달할 때 실행된다.
	   * 컴포넌트에 내려오는 데이터 포맷을 템플릿에 필요한 포맷으로 변형하려면 오버라이딩 해서 사용한다
	   * 템플릿에 데이터가 내려간다면 리턴값은 무조건 존재해야한다.
	   * @param data
	   * @returns {*}
	   */
	  toTemplateDataFormat: function toTemplateDataFormat(data) {
	    return data;
	  },
	  render: function render() {
	    this.destroy();
	    this.beforeRender();
	    this.html = this._render(this.toTemplateDataFormat(this.data));
	    this.$html = (0, _jquery2['default'])(this.html);
	    this.afterRender();
	
	    return this.$html.get(0);
	  },
	  beforeDestroy: function beforeDestroy() {},
	  afterRender: function afterRender() {},
	  beforeRender: function beforeRender() {},
	  _unbindComponentEvents: function _unbindComponentEvents() {
	    var _this = this;
	
	    _jquery2['default'].each(this.eventTargets, function (idx, _ref2) {
	      var target = _ref2.target,
	          etype = _ref2.etype,
	          callback = _ref2.callback;
	
	      _this.$html.off(etype, target, callback);
	    });
	  },
	  _render: function _render(data) {
	    return this.template.render(data);
	  },
	  destroy: function destroy() {
	    this.beforeDestroy();
	    this._unbindComponentEvents();
	    if (this.$html) {
	      this.$html.remove();
	    }
	  },
	  getElement: function getElement(query) {
	    return this.$html.find(query);
	  }
	};
	
	exports['default'] = Component;

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var AJAX_PAGE_PER_COUNT = exports.AJAX_PAGE_PER_COUNT = 80; //ajax request 시의 data page set 단위 (pc/mo, tot/tab 에 따라 다름.)
	var USE_THUMB_SIZE = exports.USE_THUMB_SIZE = 200;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getDefaultLineState() {
	  var moreState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _jquery2['default'].extend({}, {
	    accImageWidth: 0,
	    accImageHeight: 0,
	    minImageHeight: 9999,
	    maxImageHeight: 0,
	    imageStartAt: 0,
	    imageCount: 0,
	    isWidthFixed: false,
	    isWidthNormal: false,
	    widthFixedCount: 0,
	    accImageWidthNext: 0,
	    accImageStepNext: 0,
	    accDivWidth: 0
	  }, moreState);
	}
	
	exports['default'] = getDefaultLineState;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _thumb_board = __webpack_require__(17);
	
	var _thumb_board2 = _interopRequireDefault(_thumb_board);
	
	var _utils = __webpack_require__(2);
	
	var _converter = __webpack_require__(11);
	
	var _converter2 = _interopRequireDefault(_converter);
	
	var _button_extend = __webpack_require__(10);
	
	var _button_extend2 = _interopRequireDefault(_button_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultConfig = {
	  isImageDataEnd: false,
	  thumbBoard: {}
	};
	
	function ImageApp($appTarget, config) {
	  this.$app = $appTarget;
	  this.config = _jquery2['default'].extend({}, defaultConfig, config);
	  this.state = {
	    dataPageNum: 1,
	    ajaxRequestCount: 0,
	    moreBtnClickCnt: 0, // 통검용 펼쳐보기 카운트 (이 값으로 4번 이후 접기 동작을 제어한다.), -> 2014.05.28, 탭 80건 노출로 펼쳐보기 1회 줄임
	    visibleLine: 0, // 통검용 라인 트래킹 카운트
	    totalAjaxRequestCnt: 0, // 총 ajax 카운트
	    isImageDataEnd: this.config.isImageDataEnd,
	    isUserReportMode: window.SF.getParam('cnucc') === '1',
	    preventAjaxCall: false,
	    reachedAjaxCallLimit: false,
	    resizeStart: 0
	  };
	
	  // Core Components
	  this.thumbBoard = new _thumb_board2['default'](this.config.data, $appTarget, this.config.thumbBoard, this.state);
	  this.$loadingSpinner = this.config.loadingSpinner ? (0, _jquery2['default'])(this.config.loadingSpinner) : null;
	  this.btnExtend = this.config.buttonExtendSelector ? new _button_extend2['default'](this.$app, this.config.buttonExtendSelector) : null;
	
	  this.init();
	}
	
	ImageApp.prototype = {
	  fetchData: function fetchData(params) {
	    var _this = this;
	
	    var url = (0, _utils.makeAjaxRequestUri)(params);
	    return _jquery2['default'].ajax(url, {
	      method: 'GET',
	      timeout: 2500
	    }).then(function (data) {
	      return typeof data === 'string' ? _jquery2['default'].parseJSON(data) : data;
	    }).fail(function () {
	      _this.showLoadingSpinner(false);
	    });
	  },
	  showLoadingSpinner: function showLoadingSpinner(show) {
	    show ? this.$app.trigger('load:start') : this.$app.trigger('load:end');
	    if (!this.$loadingSpinner) {
	      return;
	    }
	    show ? this.$loadingSpinner.show() : this.$loadingSpinner.hide();
	  },
	  getMoreData: function getMoreData(params, eventType) {
	    var _this2 = this;
	
	    if (eventType === 'click') {
	      this.state.ajaxRequestCount = 0;
	    }
	    this.state.ajaxRequestCount++;
	    this.state.preventAjaxCall = true;
	    this.showLoadingSpinner(true);
	    return this.fetchData(params).then(function (data) {
	      var ds = '';
	      var isEnd = false;
	      var endType = '';
	
	      try {
	        var spreadImage = data.RESULT.SPREAD_TAB_IMAGE || data.RESULT.SPREAD_IMAGE;
	        ds = spreadImage.r.ds;
	        isEnd = spreadImage.r.m.is_end.toLowerCase() === 'true';
	        endType = spreadImage.r.m.endType;
	      } catch (e) {
	        // 로딩 이미지 숨김.
	        _this2.showLoadingSpinner(false);
	        return;
	      }
	
	      var hasData = typeof ds !== 'string';
	
	      if (!hasData) {
	        return;
	      }
	
	      if (isEnd) {
	        _this2.state.isImageDataEnd = true;
	        _this2.$app.trigger({
	          type: 'data:end',
	          endType: endType
	        });
	      }
	      _this2.state.totalAjaxRequestCnt++;
	      _this2.state.dataPageNum++;
	      var refinedData = (0, _converter2['default'])(ds);
	      _this2.thumbBoard.updateData(refinedData, function (startIdx) {
	        _this2.thumbBoard.renderImages(startIdx);
	        _this2.thumbBoard.resizeImages();
	        SF.userReportExec && SF.userReportExec.init();
	      });
	      _this2.showLoadingSpinner(false);
	    });
	  },
	
	
	  /**
	   * 내려받은 이미지 전체의 크기값을 재연산 한다
	   * @param callback
	   */
	  refresh: function refresh(callback) {
	    this.thumbBoard.setImageDiv();
	    this.thumbBoard.resizeImages();
	    if (callback) {
	      callback();
	    }
	  },
	  init: function init() {
	    var _this3 = this;
	
	    // $app에 이벤트 리스너를 달려면 thumboard에서 데이터를 가공하고 render 이벤트를 emit 하는 시점이 event loop 뒤로 가야함
	    setTimeout(function () {
	      _this3.thumbBoard.init();
	    }, 0);
	  }
	};
	
	exports['default'] = ImageApp;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _no_image_msg = __webpack_require__(28);
	
	var _no_image_msg2 = _interopRequireDefault(_no_image_msg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $tmpl = _jquery2['default'].templates(_no_image_msg2['default']);
	
	function ButtonExtend($ctx, selector) {
	  this.$elem = $ctx.find(selector);
	  this.$html = '';
	}
	
	ButtonExtend.prototype = {
	  show: function show() {
	    this.$elem.show();
	  },
	  hide: function hide() {
	    this.$elem.hide();
	  },
	  getMessageTemplate: function getMessageTemplate(endType) {
	    this.$html = $tmpl.render({ endType: endType });
	    return this.$html;
	  },
	  on: function on(etype, target, callback) {
	    this.$elem.on(etype, target, callback);
	  }
	};
	
	exports['default'] = ButtonExtend;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _configs = __webpack_require__(7);
	
	var _utils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var errorImageType = '600x0_65_wr';
	var useImageType = '0x200_85_hr';
	
	function toThumbBoardItemFormat(ds) {
	  var dataList = ds.data;
	  var refinedData = Object.prototype.toString.call(dataList) === '[object Array]' ? _jquery2['default'].map(dataList, refineData) : [refineData(dataList)];
	  return _jquery2['default'].map(refinedData, makeThumbBoardData);
	}
	
	function makeThumbBoardData(data) {
	  var thumb = data.thumbnail;
	  var w = data.w;
	  var h = data.h;
	  return {
	    ndid64: data.ndid64,
	    docid: data.docid,
	    docdsid: data.docdsid,
	    url: thumb.url,
	    w: w,
	    h: h,
	    dw: w,
	    dh: h,
	    iw: w,
	    ih: h,
	    info: {
	      title: data.org_title.replace(/"/g, "&quot;"),
	      htitle: data.title.replace(/"/g, "&quot;"),
	      summary: data.contents_summary.replace(/"/g, "&quot;"),
	      filesize: data.filesize,
	      ow: parseInt(data.width, 10),
	      oh: parseInt(data.height, 10),
	      docurl: data.docurl,
	      disdocurl: data.display_docurl,
	      oimgurl: data.alter_imgurl,
	      overcpname: data.display_collection_name.replace(/"/g, "&quot;").replace(/>/g, "&gt;"),
	      cpname: data.display_cpname.replace(/"/g, "&quot;").replace(/>/g, "&gt;"),
	      cpid: data.cpid,
	      auth: "",
	      cclc: data.ccl_commercial,
	      ccld: data.ccl_derivative,
	      regdate: (0, _utils.makeDateStr)(data.regdttm),
	      cropfocus: getCropFocus(thumb)
	    },
	    errorthumb: data.errorthumb
	  };
	}
	
	function getCropFocus(thumb) {
	  var cropFocus = thumb.focus;
	  var shouldCenterFocus = !cropFocus || cropFocus === 'noface' || cropFocus === 'none';
	  return shouldCenterFocus ? 'center' : cropFocus;
	}
	
	function getUseThumbSize(thumb) {
	  var shouldUseMoSize = _configs.USE_THUMB_SIZE === 170;
	  var w = shouldUseMoSize ? thumb.mo_width : thumb.width;
	  var h = shouldUseMoSize ? thumb.mo_height : thumb.height;
	  return {
	    w: parseInt(w, 10),
	    h: parseInt(h, 10)
	  };
	}
	
	function refineData(data) {
	  var thumbData = data.thumbnail.data;
	  var hasThumbDataInArray = thumbData.length;
	  var result = null;
	  var errorThumb = null;
	  var defaultErrorThumb = {
	    url: '//:0',
	    w: '',
	    h: ''
	  };
	
	  if (hasThumbDataInArray) {
	    _jquery2['default'].each(thumbData, function (idx, thumb) {
	      var thumbType = thumb.type;
	      if (thumbType === useImageType) {
	        result = thumb;
	      }
	      errorThumb = errorThumb || getErrorThumbData(thumb, errorImageType);
	    });
	  } else {
	    result = thumbData.data;
	  }
	
	  var thumbSize = getUseThumbSize(result);
	
	  return result ? _jquery2['default'].extend({}, data, { thumbnail: result }, { errorthumb: errorThumb || defaultErrorThumb }, thumbSize) : null;
	}
	
	function getErrorThumbData(thumb, errorImageType) {
	  if (thumb.type === errorImageType) {
	    return {
	      url: thumb.url || '//:0',
	      w: thumb.width,
	      h: thumb.h
	    };
	  }
	  return null;
	}
	
	exports['default'] = toThumbBoardItemFormat;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.defaultState = exports.defaultConfig = undefined;
	
	var _globals = __webpack_require__(3);
	
	var defaultConfig = exports.defaultConfig = {
	  // [PC개편] 컬렉션 ID 추가.
	  imageCollId: "imgColl",
	  wrapCollId: "imgWrapColl", // 전체 width 체크용 wrap id
	  bodyListId: "imgList", // 이미지들을 append할 list의 body id
	  expandButtonId: "imgExtendView", // 더보기 버튼 id
	
	  isTab: window.param_w === 'img', // param_w가 img면 true, 아니면 false
	  isMobile: false, // mobile 여부
	
	  // 새로추가된 라인컷팅 6번 로직용 body의 over 허용량 계산시 사용되는 %률, 초기 60%로 잡았다.
	  // 이후 디바이스별로 조정 할수도 있고, pc/mo 를 분리할 경우도 생길것 같다.
	  boardOverflowLimit: 0.5,
	
	  // zoom crop의 배율 10% -> 0.1
	  cropMagnification: 0.2,
	
	  // 통검일때만 사용하는 옵션
	  // 패턴 키워드일때 컬렉션 기본 노출 line 조정 (2->3)
	  showLineCount: 2,
	
	  // 고정된 DIV 사이즈를 가져야 하는 fixed 이미지들의 div 고정 값 (PC tab 기본값, 그외는 하단에서 override)
	  // PC Tab (W:77 / H:162), 그외 pc tot, mo (W:68 / H:90)
	  fixedImageDivWidth: 77,
	  fixedImageDivHeight: 162,
	
	  minImageDivHeight: 9999,
	  maxImageDivHeight: 0,
	
	  useImageType: "0x200_85_hr", // PC Tab 기본값, data에서 사용될 썸네일 사이즈 type 값.
	  useThumbPx: 200, // 썸네일의 기본 수치값을 사용한 사이즈 (170 이면 170수치값 mo_width, mo_height를 사용)
	  bodyLimitWidth: 832, // PC tab 기본값, window의 최소 resize width 값, 해당 값 이하로 width가 더 줄어들지 않는다.
	  imageDivMargin: 3, // PC tab 기본값, 이미지의 div 기본 여백 margin 값. (비율 계산시에도 사용됨)
	
	  defaultMoreBtnClassName: "coll_extend extend_type5 extend_imgtab", // PC Tab 기본값. 펼쳐보기의 className
	
	  userReportMode: false, // PC 통검 전용. 신고하기 동작이 달라서 값을 따로 뺌.
	  freeLogStr: "https:" + window.SEARCHLOGDOMAIN + "/fr/imgviewer/p?vle=",
	  dataIsEndByFirstPage: false, // 첫 페이지 데이터가 isEnd 인지 표시하는 flag
	  imageViewerLink: "?w=imgviewer&q=AOA%20%EC%82%AC%EC%A7%84", //mo 전용, 뷰어로 이동하기 위한 기본 link param
	  utf8Query: _globals.utf8Query, // 쿼리 utf8
	  addLinkParam: "", //링크에 추가되는 param option
	  addQsearchParam: "", // ajax request 시 추가되는 param option
	
	  // 클릭코드의 기본 값. pc/mo, tot/tab 별로 달라진다. 기본은 tab
	  basicCode: {
	    "s": "IM",
	    "a": "IMTO",
	    "dc": "IIM"
	  }
	};
	
	var defaultState = exports.defaultState = {
	
	  // pc 통검용 펼쳐보기 UI -> 접기 강제 전환 flag
	  // 마지막 펼쳐보기 시에는 접기 UI가 변경 되어야 한다. (펼쳐보기+접기 X, 접기만 O)
	  flagMoreUiBtnReset: false,
	
	  // PC통검 전용,
	  // 접기가 한번 노출 된 이후,
	  // 즉. ajax response로 인해 누적된 데이터가 이 후 펼쳐보기 시도에서 충분하다 판단할 수 있게 하는 flag,
	  // true인 경우 펼쳐보기시 데이터 추가로드를 하지 않는다.
	  flagNoMoreAjaxRequestToBtn: false,
	
	  // ajax request 제어 flag, true면 데이터를 추가로 호출하지 않음.
	  flagAjaxRequestLock: false,
	
	  indexImageInDoc: 0, // 뷰어 open 후 문서내 이미지 api 호출한 indexImageInViewer 값. async라 연속적인 viewer open 시 response time으로 인해 sync가 틀어지는 것을 체크. 값이 다르면 load 하지 않음.
	  stepScrollSize: 0, //PC전용, viewer open 시 window의 scroll 값을 저장하고 있다.
	
	  lineCountOfTotalRenderImage: 0 // 화면에 render한 현상태의 총 line count, window가 resize되면 이 값도 변한다.
	
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function calcImageSize(defaultConfig) {
	
	  var DEFAULT_DIV_WIDTH = defaultConfig.fixedImageDivWidth + defaultConfig.imageDivMargin;
	
	  function calcImgSizeByRatio(imagesInLine, state, lineState, forEachCalc) {
	    var accImageWidthWithoutFixed = lineState.accImageWidth - DEFAULT_DIV_WIDTH * lineState.widthFixedCount;
	    var calcState = {
	      visibleLineCount: 1,
	      accDivWidth: 0,
	      calcDivHeight: 0,
	      calcWidth: 1,
	      widthRatio: 0
	    };
	
	    _jquery2['default'].each(imagesInLine, function (idx, data) {
	      calcState.calcWidth = getCalcWidth(data, accImageWidthWithoutFixed, lineState, state.isSingleLine);
	      calcState.widthRatio = getWidthRatioByCalcWidth(calcState.calcWidth, data);
	      setCalcDivHeightState(calcState, lineState);
	      forEachCalc(calcState, data);
	
	      data.lineCount = state.lineCount;
	    });
	  }
	
	  function setCalcDivHeightState(calcState, lineState) {
	    if (calcState.calcDivHeight > 0) {
	      return;
	    }
	    var fixedHeight = defaultConfig.fixedImageDivHeight;
	    var maxImgHeight = lineState.maxImageHeight;
	    var isShorterThanDefault = maxImgHeight < fixedHeight;
	    calcState.calcDivHeight = isShorterThanDefault ? fixedHeight : Math.round(maxImgHeight - maxImgHeight * calcState.widthRatio);
	    // calcState.calcDivHeight += (calcState.calcDivHeight * defaultConfig.cropMagnification);
	  }
	
	  return calcImgSizeByRatio;
	}
	
	function getWidthRatioByCalcWidth(calcWidth, data) {
	  var ratio = calcWidth / data.w * 100;
	  return Math.ceil(ratio) * 0.01;
	}
	
	function getCalcWidth(data, accImageWidthWithoutFixed, lineState, isSingleLine) {
	  var calcWidth = 1;
	  // 1. 개별 math_w 를 구해서, w_per를 구한다.
	  // image_add_w_without_fixed이 0인 경우는 전부다 fixed type
	  if (accImageWidthWithoutFixed > 0) {
	    calcWidth = lineState.gap * data.w / accImageWidthWithoutFixed;
	  }
	  // 표시될 이미지 라인이 1개 밖에 안되는 경우, 박스 사이즈 계산이 이미지보다 커지지 않도록 보정한다.
	  if (isSingleLine && calcWidth < 0) {
	    calcWidth = 1;
	  }
	  return calcWidth;
	}
	
	exports['default'] = calcImageSize;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _get_line_state = __webpack_require__(8);
	
	var _get_line_state2 = _interopRequireDefault(_get_line_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function handleLastLine(appState, state, imageDataItems, callback, defaultConfig) {
	  var hasRemainingImages = state.lastIndex < state.dataSize - 1 && state.lineCount > 0;
	  if (!hasRemainingImages) {
	    return;
	  }
	
	  var hasOnlyOnePageVolume = appState.isImageDataEnd && appState.dataPageNum === 1;
	  var lastLine = getLastLine(imageDataItems, state.lineCount);
	  setDataLineCount(lastLine, state);
	
	  if (hasOnlyOnePageVolume) {
	    var lastLineState = (0, _get_line_state2['default'])();
	    _jquery2['default'].each(lastLine, function (idx, data) {
	      if (data.w >= defaultConfig.fixedImageDivWidth) {
	        lastLineState.accImageWidth += data.w;
	      } else {
	        lastLineState.accImageWidth += defaultConfig.fixedImageDivWidth + defaultConfig.imageDivMargin;
	        lastLineState.widthFixedCount++;
	      }
	
	      lastLineState.accImageHeight += data.h;
	
	      if (lastLineState.minImageHeight > data.h) {
	        lastLineState.minImageHeight = data.h;
	      }
	
	      if (lastLineState.maxImageHeight < data.h) {
	        lastLineState.maxImageHeight = data.h;
	      }
	    });
	
	    state.lineCount++;
	    state.isSingleLine = true;
	    callback(lastLine, state, lastLineState);
	  } else {
	    hideThumbnails(lastLine);
	  }
	}
	
	function getLastLine(imageDataItems) {
	  return _jquery2['default'].map(imageDataItems, function (image) {
	    return image.isInLastLine ? image : null;
	  });
	}
	
	function hideThumbnails(thumbs) {
	  _jquery2['default'].each(thumbs, function (idx, data) {
	    data.hide = 'Y';
	  });
	}
	
	function setDataLineCount(thumbs, state) {
	  _jquery2['default'].each(thumbs, function (idx, data) {
	    data.lineCount = state.lineCount + 1;
	  });
	}
	
	exports['default'] = handleLastLine;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _calc_image_size = __webpack_require__(13);
	
	var _calc_image_size2 = _interopRequireDefault(_calc_image_size);
	
	var _set_image_style = __webpack_require__(16);
	
	var _set_image_style2 = _interopRequireDefault(_set_image_style);
	
	var _handle_last_line = __webpack_require__(14);
	
	var _handle_last_line2 = _interopRequireDefault(_handle_last_line);
	
	var _get_line_state = __webpack_require__(8);
	
	var _get_line_state2 = _interopRequireDefault(_get_line_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function ImageCalculator(defaultConfig) {
	  var DEFAULT_DIV_WIDTH = defaultConfig.fixedImageDivWidth + defaultConfig.imageDivMargin;
	
	  /**
	   * getAddImageWidth
	   * 1줄당 이미지 커팅을 위해서 로직체크를 할때, 해당 이미지가 fix사이즈로 div고정이 될지
	   * 아니면 기본적인 영역계산으로 될지 반환하는 메소드,
	   * 해당 부분이 mathImageDiv에 비슷하게 존재하지만,
	   * 계산전에 커팅하는 단계에서도 알아야 하기 때문에 메소드로 따로 만듬.
	   * @param tmp_img_data imgDataObject
	   * @returns int
	   */
	  function getAddImageWidth(tmp_img_data) {
	    if (typeof tmp_img_data === "undefined") {
	      return 0;
	    }
	    return tmp_img_data.w >= defaultConfig.fixedImageDivWidth ? tmp_img_data.w : defaultConfig.fixedImageDivWidth + defaultConfig.imageDivMargin;
	  }
	
	  function setImageSizeToData(appState, boardState, imageDataItems) {
	    var boardWidth = boardState.boardWidth;
	    var maxBodyWidthOverflow = boardWidth + Math.floor(boardWidth * defaultConfig.boardOverflowLimit);
	    var state = {
	      boardWidth: boardWidth,
	      maxBodyWidthOverflow: maxBodyWidthOverflow,
	      lastIndex: 0,
	      lineCount: 0,
	      isSingleLine: true,
	      dataSize: imageDataItems.length
	    };
	
	    // 매번 계산시 마지막 라인에 들어가는 이미지인지 확인하기위해 마커 추가
	    _jquery2['default'].each(imageDataItems, function (idx, each) {
	      each.isInLastLine = true;
	    });
	    countImagesForEachLine(state, imageDataItems, function (imagesInLine, state, lineState) {
	      _jquery2['default'].each(imagesInLine, function (idx, eachImageData) {
	        // 이 콜백 라인에는 하나의 라인을 이루는 각각의 아이템들이 들어오는데,
	        // 마지막 라인에 있는 이미지는 이 콜백에 들어오지 못한다
	        // handleLastLine에서 isInLastLine === true인 아이템을 잡아오기 위해 사용한다
	        eachImageData.isInLastLine = false;
	      });
	      calculateImageDivSize(imagesInLine, state, lineState);
	    });
	
	    // 꽉 채워지지 않은 마지막 라인의 이미지에 대한 처리
	    // 콜백은 초기화면시 이미지 수가 너무 적어 모두 노출해야 하는 케이스일때 실행된다
	    (0, _handle_last_line2['default'])(appState, state, imageDataItems, function (lastLine, state, lastLineState) {
	      var lastLineStateParam = _jquery2['default'].extend({}, lastLineState, {
	        gap: lastLineState.accImageWidth - state.boardWidth
	      });
	      state.lastIndex = state.lastIndex + lastLine.length;
	      calculateImageDivSize(lastLine, state, lastLineStateParam);
	    }, defaultConfig);
	
	    function calculateImageDivSize(imagesInLine, state, lineState) {
	      (0, _calc_image_size2['default'])(defaultConfig)(imagesInLine, state, lineState, function (calcState, eachImageData) {
	        (0, _set_image_style2['default'])(defaultConfig)(calcState, eachImageData);
	        lineState.accDivWidth += eachImageData.dw;
	        eachImageData.vTarget = state.lastIndex;
	        adjustLastImageOfEachLine(eachImageData, state, lineState, calcState);
	      });
	    }
	  }
	
	  function adjustLastImageOfEachLine(data, state, lineState) {
	    if (data.index !== lineState.lastIdx) {
	      return;
	    }
	
	    // 일단 라인당 남는 오차에 대한 보정은 맨 마지막이 fix type인 경우에만 하도록 둔다.
	    // flag_single_line == true 일땐 하지 않는다.
	    if (data.fixed && state.isSingleLine) {
	      //라인당 남는 오차
	      var misCalc = lineState.accDivWidth + defaultConfig.imageDivMargin * lineState.imageCount - state.boardWidth;
	      // body가 남는 경우.
	      // 처음 메소드가 호출되기 위해 한줄당 이미지 개수를 구하는 로직과 연결된다.
	      // 그 로직에서 다음 이미지까지 더했을때 bodyWidth가 넘을 경우에도 로직이 실행되기 때문에, 부족한 경우에만 마지막 div의 넓이를 조정한다.
	      if (misCalc < 0 && Math.abs(misCalc) > 5) {
	        data.dw += Math.abs(misCalc);
	      }
	    }
	
	    // 1줄에 1개 밖에 못나오는 경우.
	    // 이미지를 div에 꽉차게 늘린다.
	    // fixed가 아닌경우에만 한다. fixed도 늘리면 너무 모양이 이상해진다.
	    if (lineState.imageStartAt === lineState.lastIdx && !state.isSingleLine && !data.fixed) {
	      var zoomRatio = (data.dw - data.iw) / data.iw;
	      data.dh = Math.round(data.ih + data.ih * zoomRatio);
	      data.css = { width: '100%', height: '100%' };
	    }
	  }
	
	  function countImagesForEachLine(state, imageDataItems, forEachLine) {
	    var lineState = (0, _get_line_state2['default'])(state);
	    var line = [];
	    _jquery2['default'].each(imageDataItems, function (idx, data) {
	      var nextData = imageDataItems[idx + 1];
	
	      setAccImageWidthByImageSize(lineState, data);
	      setImageHeight(lineState, data);
	      lineState.imageCount++;
	      data.index = idx;
	      checkSingleLine(state, nextData);
	      setAccImageNext(lineState, nextData);
	
	      line.push(data);
	
	      onLineComplete(lineState, state, function () {
	        state.lineCount++;
	        state.lastIndex = idx;
	
	        var stateParam = _jquery2['default'].extend({}, lineState, {
	          gap: lineState.accImageWidth - state.boardWidth
	        });
	
	        forEachLine(line, state, stateParam);
	
	        line = [];
	        lineState = (0, _get_line_state2['default'])(_jquery2['default'].extend({}, state, {
	          imageStartAt: idx + 1
	        }));
	      });
	    });
	
	    function setAccImageWidthByImageSize(lineState, data) {
	      if (data.w >= defaultConfig.fixedImageDivWidth) {
	        lineState.accImageWidth += data.w;
	        lineState.isWidthNormal = true;
	        data.fixed = false;
	      } else {
	        lineState.accImageWidth += DEFAULT_DIV_WIDTH;
	        lineState.isWidthFixed = true;
	        data.fixed = true;
	        lineState.widthFixedCount++;
	      }
	    }
	
	    function setImageHeight(lineState, data) {
	      var h = data.h;
	      lineState.accImageHeight += h;
	      if (lineState.minImageHeight > h) {
	        lineState.minImageHeight = h;
	      }
	      if (lineState.maxImageHeight < h) {
	        lineState.maxImageHeight = h;
	      }
	    }
	
	    function checkSingleLine(state, nextData) {
	      state.isSingleLine = getAddImageWidth(nextData) === 0 && state.lineCount === 0;
	    }
	
	    function setAccImageNext(lineState, nextData) {
	      lineState.accImageWidthNext = lineState.accImageWidth + getAddImageWidth(nextData);
	      lineState.accImageStepNext = (lineState.accImageWidthNext - lineState.boardWidth) / lineState.imageCount;
	    }
	
	    function onLineComplete(lineState, state, callback) {
	      var isOverBoardWidth = lineState.accImageWidth >= lineState.boardWidth;
	      var hasOnlyFixedWidth = lineState.isWidthFixed && !lineState.isWidthNormal;
	      var hasBothImageTypes = lineState.isWidthFixed && lineState.isWidthNormal;
	      var isNextWidthOverBoard = lineState.accImageWidthNext >= lineState.boardWidth;
	      var isNextStepOverBoard = lineState.accImageStepNext >= defaultConfig.fixedImageDivWidth;
	      var isGoingToOverflow = lineState.accImageWidthNext >= lineState.maxBodyWidthOverflow;
	
	      var isLineComplete = isOverBoardWidth || hasOnlyFixedWidth && isNextWidthOverBoard || hasBothImageTypes && isNextWidthOverBoard && isNextStepOverBoard || state.isSingleLine || isGoingToOverflow;
	
	      if (isLineComplete) {
	        callback();
	      }
	    }
	  }
	
	  return setImageSizeToData;
	}
	
	exports['default'] = ImageCalculator;

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function setImageStyle(defaultConfig) {
	
	  function setImageStyleData(calcState, data) {
	    var cropCss = {};
	    var cropFocus = data.info.cropfocus;
	    setDivRectSize(calcState, data);
	    setImageRectSize(data, calcState.widthRatio);
	    var cropSize = getCropSize(data);
	    setHorizontalCropCss(cropCss, cropFocus, cropSize);
	
	    if (data.fixed) {
	      revertImageSizeOnFixedDiv(data, cropCss);
	    } else {
	      zoomImagesBiggerThanDiv(calcState, data, function (cropSize) {
	        cropCss = {};
	        setHorizontalCropCss(cropCss, cropFocus, cropSize);
	      });
	    }
	
	    data.css = cropCss;
	    data.hide = 'N';
	  }
	
	  function setDivRectSize(calcState, data) {
	    data.dw = !data.fixed ? data.w - (calcState.calcWidth + defaultConfig.imageDivMargin) : defaultConfig.fixedImageDivWidth;
	    data.dh = calcState.calcDivHeight;
	  }
	
	  function setImageRectSize(data, ratio) {
	    data.iw = Math.round(data.w - data.w * ratio);
	    data.ih = Math.round(data.h - data.h * ratio);
	  }
	
	  function setHorizontalCropCss(cropCss, cropfocus, cropSize) {
	    switch (cropfocus) {
	      case 'left':
	        cropCss.marginLeft = '0px';
	        break;
	      case 'right':
	        cropCss.marginLeft = '-' + cropSize * 2 + 'px';
	        break;
	      default:
	        cropCss.marginLeft = '-' + cropSize + 'px';
	    }
	  }
	
	  function setVeticalCropCss(cropCss, data) {
	    cropCss.marginTop = Math.round((data.dh - data.ih) * 0.5) + 'px';
	  }
	
	  function revertImageSizeOnFixedDiv(data, cropCss) {
	    data.iw = data.w;
	    data.ih = data.h;
	    if (data.dh > data.ih) {
	      setVeticalCropCss(cropCss, data);
	    }
	  }
	
	  function zoomImagesBiggerThanDiv(calcState, data, callback) {
	    var calcDh = calcState.calcDivHeight;
	    var zoomSize = calcDh - data.ih;
	    if (zoomSize > 0) {
	      data.iw = data.iw + Math.round(data.iw * zoomSize / data.ih);
	      data.ih = calcDh;
	
	      var cropSize = getCropSize(data);
	      if (cropSize > 0) {
	        callback(cropSize);
	      }
	    }
	  }
	
	  function getCropSize(data) {
	    return Math.floor((data.iw - data.dw) / 2);
	  }
	
	  return setImageStyleData;
	}
	
	exports['default'] = setImageStyle;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _thumb_board = __webpack_require__(18);
	
	var _thumb_board2 = _interopRequireDefault(_thumb_board);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _thumb_board2['default'];

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _thumbnail = __webpack_require__(19);
	
	var _thumbnail2 = _interopRequireDefault(_thumbnail);
	
	var _tab_params = __webpack_require__(5);
	
	var _tab_params2 = _interopRequireDefault(_tab_params);
	
	var _default_settings = __webpack_require__(12);
	
	var _image_calculator = __webpack_require__(15);
	
	var _image_calculator2 = _interopRequireDefault(_image_calculator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function ThumbBoard(data, $ctx, config, appState) {
	  var conf = _jquery2['default'].extend({}, _default_settings.defaultConfig, config);
	
	  this.config = conf;
	
	  this.thumbnails = [];
	  this.data = data;
	  this.appState = appState;
	
	  this.$ctx = $ctx;
	
	  this.$areaWrapper = $ctx.find(conf.areaWrapper);
	  this.$board = $ctx.find(conf.board);
	
	  this.state = _default_settings.defaultState;
	}
	
	ThumbBoard.prototype = {
	  /**
	   * setBodyWidthByBrowser
	   * 이미지가 그려질 영역의 width값을 셋팅하는 메소드
	   */
	  setBoardWidth: function setBoardWidth() {
	    // [PC개편] 탭의 이미지가 그려질 가로사이즈를 마진을 포함하여 계산.
	    // 배열계산로직에 여백이 3px 정도 들어가 있다. 따라서 (그려질 구역의 마진 * 2(양쪽) - 3px)
	    this.state.boardWidth = this.$ctx.width() - (this.$areaWrapper.get(0).offsetLeft * 2 - 3);
	    this.$board.css('width', this.state.boardWidth + "px");
	  },
	
	  /**
	   * setImageDiv
	   * 1줄에 들어갈 이미지의 개수를 정하는 메소드
	   * 해당 메소드에서 1줄당 이미지 개수 컷팅을 해서
	   * mathImageDiv 메소드로 보내 1줄마다의 이미지들에 대한 resizing을 완성한다.
	   */
	  setImageDiv: function setImageDiv() {
	    /* this.body 의 width를 재조정. */
	    this.setBoardWidth();
	    (0, _image_calculator2['default'])(this.config)(this.appState, this.state, this.data);
	  },
	  loadImages: function loadImages(thumbs) {
	    _jquery2['default'].each(thumbs, function (idx, thumb) {
	      if (!thumb.imageLoaded) {
	        thumb.startImageLoad();
	      }
	    });
	  },
	  updateData: function updateData(newData, callback) {
	    var startIdx = this.data.length;
	    this.data = this.data.concat(newData);
	    this.setImageDiv();
	    if (typeof callback === 'function') {
	      callback(startIdx);
	    }
	  },
	  insertElement: function insertElement($elementHTML, idx) {
	    if ($elementHTML) {
	      $elementHTML.insertAfter(this.thumbnails[idx].$html);
	    }
	  },
	  _makeThumbnailHTMLElements: function _makeThumbnailHTMLElements(startIdx) {
	    var _this = this;
	
	    var frag = document.createDocumentFragment();
	    var thumbs = _jquery2['default'].map(this.data, function (data, idx) {
	      if (idx < startIdx) {
	        return null;
	      }
	      return new _thumbnail2['default']({ data: data }, _this.$board, _tab_params2['default'], idx);
	    });
	    this.thumbnails = this.thumbnails.concat(thumbs);
	
	    _jquery2['default'].each(thumbs, function (idx, thumbnail) {
	      var thumb = thumbnail.render();
	      frag.appendChild(thumb);
	    });
	    return frag;
	  },
	  renderImages: function renderImages() {
	    var startIdx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var newImages = this._makeThumbnailHTMLElements(startIdx);
	    this.$board.get(0).appendChild(newImages);
	    this.loadImages(this.thumbnails);
	    this.appState.preventAjaxCall = false;
	    this.$ctx.trigger('render');
	  },
	  resizeImages: function resizeImages() {
	    var _this2 = this;
	
	    _jquery2['default'].each(this.data, function (idx, each) {
	      var thumb = _this2.thumbnails[idx];
	      thumb.$html.css({
	        width: Math.floor(each.dw) + 'px',
	        height: each.dh + 'px',
	        marginRight: '',
	        display: each.hide === 'Y' ? 'none' : 'block'
	      });
	      thumb.$img.css(_jquery2['default'].extend({
	        width: each.iw + 'px',
	        height: each.ih + 'px'
	      }, each.css));
	      thumb.$a.css({
	        width: Math.floor(each.dw) - 2 + 'px',
	        height: each.dh - 2 + 'px'
	      });
	    });
	    this.$ctx.trigger({ type: 'thumb:resize' });
	  },
	  init: function init() {
	    this.setImageDiv();
	    this.renderImages();
	    this.$ctx.trigger('init');
	  }
	};
	
	exports['default'] = ThumbBoard;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _component = __webpack_require__(6);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _thumbnail = __webpack_require__(29);
	
	var _thumbnail2 = _interopRequireDefault(_thumbnail);
	
	var _utils = __webpack_require__(2);
	
	var _globals = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isReportMode = SF.getParam('cnucc') === '1';
	var LINK_SELECTOR = '.link_thumb';
	var IMAGE_SELECTOR = '.thumb_img';
	var INFO_SELECTOR = '.info_img';
	var INFO_LINK_SELECTOR = '.info_img a.btn_original';
	
	/**
	 * 개별 썸네일 HTML을 렌더링 하고 이벤트를 제공
	 * @param compConf
	 * @param $app
	 * @param tabParams
	 * @param idx
	 * @constructor
	 */
	function Thumbnail(compConf, $app, tabParams, idx) {
	  _component2['default'].call(this, compConf);
	
	  this.$app = $app;
	  this.setTemplate(_thumbnail2['default']);
	  this.state = {
	    imageLoaded: false,
	    loadStatus: 0
	  };
	  this.data.tabParams = tabParams;
	  this.data.index = idx;
	}
	
	(0, _utils.inherit)(Thumbnail, _component2['default'], {
	  afterRender: function afterRender() {
	    var $app = this.$app;
	    this.$img = this.getElement(IMAGE_SELECTOR);
	    this.$a = this.getElement(LINK_SELECTOR);
	    var thumbnail = this;
	    this.addEventListener([LINK_SELECTOR, INFO_SELECTOR].join(','), 'click', function (e) {
	      $app.trigger({ type: 'thumb:click', originalEvent: e, imageData: thumbnail.data, thumbnail: thumbnail, targetLink: this });
	    });
	    this.addEventListener(INFO_LINK_SELECTOR, 'click', function (e) {
	      e.stopPropagation();
	      $app.trigger({ type: 'thumbinfo:click', originalEvent: e, imageData: thumbnail.data, thumbnail: thumbnail, targetLink: this });
	    });
	  },
	  toTemplateDataFormat: function toTemplateDataFormat(data) {
	    var item = data;
	    var dw = Math.floor(item.dw);
	    var imageStyle = _jquery2['default'].extend({
	      width: item.iw + 'px',
	      height: item.ih + 'px'
	    }, data.css);
	
	    var infoText = this._getinfoHTML(item.info, data.tabParams);
	
	    var templateData = {
	      wrapper_width: dw,
	      wrapper_height: item.dh,
	      idx: item.index,
	      docid: item.docid,
	      title: item.info.title,
	      htitle: item.info.htitle,
	      imageSize: item.iw,
	      infoHTML: {
	        isNumberType: !!infoText,
	        infoText: infoText || item.info.overcpname
	      },
	      imageUrl: item.url,
	      imageStyle: (0, _utils.toCssString)(imageStyle),
	      linkStyle: (0, _utils.toCssString)({
	        width: dw - 2 + 'px',
	        height: item.dh - 2 + 'px'
	      }),
	      wrapperStyle: (0, _utils.toCssString)({
	        width: dw + 'px',
	        height: item.dh + 'px',
	        display: item.hide === 'Y' ? 'none' : 'block'
	      }),
	      originalUrl: item.info.docurl,
	      linkUrl: (0, _utils.makeRequeryUrl)(item.docid, _globals.utf8Query, window.location.search),
	      isReportMode: isReportMode
	    };
	
	    return templateData;
	  },
	  _getinfoHTML: function _getinfoHTML(itemInfo, tabParams) {
	    switch (true) {
	      case tabParams.Size !== '':
	        return itemInfo.ow + 'x' + itemInfo.oh;
	      case tabParams.SortType === 'recency':
	      case tabParams.sd !== '' || tabParams.ed !== '':
	      case itemInfo.overcpname === '뉴스':
	        return itemInfo.regdate;
	      case tabParams.CclCommercial !== '' && tabParams.CclDerivative !== '':
	        return (0, _utils.getCclHtml)(itemInfo);
	      default:
	        return null;
	    }
	  },
	  startImageLoad: function startImageLoad() {
	    var _this = this;
	
	    if (this.state.imageLoaded) {
	      return;
	    }
	    var $img = this.getElement('img');
	    var src = $img.data('src');
	    $img.on('load', function () {
	      _this.state.imageLoaded = true;
	      _this.state.loadStatus = 200;
	      _this.$app.trigger({ type: 'thumb:IIM-load', $target: $img });
	    }).on('error', function () {
	      _this.state.imageLoaded = true;
	      _this.state.loadStatus = 404;
	    });
	    $img.attr('src', src);
	  }
	});
	
	exports['default'] = Thumbnail;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ccl = __webpack_require__(27);
	
	var _ccl2 = _interopRequireDefault(_ccl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	 '1': '저작자표시',
	 '2': '저작자표시,비영리',
	 '3': '저작자표시,변경금지',
	 '4': '저작자표시,변경허락',
	 '5': '저작자표시,비영리,변경금지',
	 '6': '저작자표시,비영리,변경허락'
	
	 1. ccl_commercial = "1", ccl_derivative = "A"
	 2. ccl_commercial = "0", ccl_derivative = "A"
	 3. ccl_commercial = "1", ccl_derivative = "N"
	 4. ccl_commercial = "1", ccl_derivative = "S"
	 5. ccl_commercial = "0", ccl_derivative = "S"
	 6. ccl_commercial = "0", ccl_derivative = "N"
	 */
	
	function CclParams(icon_code, desc) {
	  this.icon_code = icon_code;
	  this.desc = desc;
	}
	
	var cclParamMap = {
	  '0': {
	    'A': [new CclParams('2', '비영리')],
	    'S': [new CclParams('2', '비영리'), new CclParams('3', '변경 금지')],
	    'N': [new CclParams('2', '비영리'), new CclParams('4', '변경 허락')]
	  },
	  '1': {
	    'N': [new CclParams('3', '변경 금지')],
	    'S': [new CclParams('4', '변경 허락')]
	  }
	};
	
	var tmpl = _jquery2['default'].templates(_ccl2['default']);
	
	function getCclHtml(itemInfo) {
	  var cclc = itemInfo.cclc;
	  var ccld = itemInfo.ccld;
	
	  var templateData = void 0;
	  try {
	    templateData = cclParamMap[cclc][ccld] || [];
	  } catch (e) {
	    templateData = [];
	  }
	
	  return tmpl.render({ data: templateData });
	}
	
	exports['default'] = getCclHtml;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function create(prototype) {
	  function F() {}
	  F.prototype = prototype;
	  return new F();
	}
	
	function inherit(subclass, superclass, newProto) {
	  var proto = create(superclass.prototype);
	  subclass.prototype = _jquery2['default'].extend(proto, newProto);
	  subclass.prototype.constructor = subclass;
	}
	
	exports['default'] = inherit;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isObject = __webpack_require__(23);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `debounce` and `throttle`.
	 *
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', debounce(calculateLayout, 150))
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }))
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * const debounced = debounce(batchLog, 250, { 'maxWait': 1000 })
	 * const source = new EventSource('/stream')
	 * jQuery(source).on('message', debounced)
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel)
	 */
	function debounce(func, wait, options) {
	  var lastArgs = void 0,
	      lastThis = void 0,
	      maxWait = void 0,
	      result = void 0,
	      timerId = void 0,
	      lastCallTime = void 0;
	
	  var lastInvokeTime = 0;
	  var leading = false;
	  var maxing = false;
	  var trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError('Expected a function');
	  }
	  wait = +wait || 0;
	  if ((0, _isObject2['default'])(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs;
	    var thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime;
	    var timeSinceLastInvoke = time - lastInvokeTime;
	    var result = wait - timeSinceLastCall;
	
	    return maxing ? Math.min(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime;
	    var timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
	  }
	
	  function timerExpired() {
	    var time = Date.now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(Date.now());
	  }
	
	  function debounced() {
	    var time = Date.now();
	    var isInvoking = shouldInvoke(time);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    lastArgs = args;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	} /* eslint-disable */
	exports['default'] = debounce;

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint-disable */
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * isObject({})
	 * // => true
	 *
	 * isObject([1, 2, 3])
	 * // => true
	 *
	 * isObject(Function)
	 * // => true
	 *
	 * isObject(null)
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  return value != null && (type == 'object' || type == 'function');
	}
	
	exports['default'] = isObject;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toParamString(obj) {
	  return Object.keys(obj).filter(function (key) {
	    return obj[key] !== '';
	  }).map(function (key) {
	    return key + '=' + obj[key];
	  }).join('&');
	}
	
	function makeRequeryUrl(docid, utf8Query, currParamString) {
	  var blacklist = ['m', 'q'];
	
	  var params = currParamString.slice(1).split('&').map(function (keyValue) {
	    var _keyValue$split = keyValue.split('='),
	        key = _keyValue$split[0],
	        val = _keyValue$split[1];
	
	    return { key: decodeURIComponent(key), val: decodeURIComponent(val) };
	  }).filter(function (param) {
	    return !blacklist.includes(param.key);
	  }).filter(function (param) {
	    return typeof param.val === 'string';
	  }).filter(function (param) {
	    return param.val.length > 0;
	  }).map(function (param) {
	    var _ref;
	
	    return _ref = {}, _ref[encodeURIComponent(param.key)] = encodeURIComponent(param.val), _ref;
	  }).reduce(function (acc, curr) {
	    return _jquery2['default'].extend({}, acc, curr);
	  }, {});
	
	  var extendedParams = _jquery2['default'].extend({}, params, {
	    w: 'img',
	    DA: 'IIM',
	    q: utf8Query,
	    docid: docid
	  });
	
	  return '?' + toParamString(extendedParams);
	}
	
	exports['default'] = makeRequeryUrl;

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function memoize(fn) {
	  var memoized = {};
	  return function (arg) {
	    var ar = JSON.stringify(arg);
	    if (typeof memoized[ar] === 'undefined') {
	      memoized[ar] = fn(arg);
	    }
	    return memoized[ar];
	  };
	}
	
	exports['default'] = memoize;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.httpsToHttp = httpsToHttp;
	exports.toRelativeProtocol = toRelativeProtocol;
	exports.toParamString = toParamString;
	exports.toParamObj = toParamObj;
	exports.makeAjaxRequestUri = makeAjaxRequestUri;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _tab_params = __webpack_require__(5);
	
	var _tab_params2 = _interopRequireDefault(_tab_params);
	
	var _configs = __webpack_require__(7);
	
	var _globals = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function httpsToHttp(url) {
	  return url.replace(/^https:\/\//, "http://");
	}
	
	function toRelativeProtocol(url) {
	  return url.replace(/^(http:|https:)/, window.location.protocol);
	}
	
	function toParamString(paramObj) {
	  var result = [];
	  for (var key in paramObj) {
	    if (paramObj.hasOwnProperty(key) && paramObj[key] !== null) {
	      result.push(key + '=' + paramObj[key]);
	    }
	  }
	
	  return result.join('&');
	}
	
	function toParamObj(paramStr) {
	  var result = {};
	  _jquery2['default'].each(paramStr.split('&'), function (idx, each) {
	    var keyValueArr = each.split('=');
	    result[keyValueArr[0]] = keyValueArr[1];
	  });
	
	  return result;
	}
	
	function makeAjaxRequestUri(params) {
	  // 클릭코드의 기본 값. pc/mo, tot/tab 별로 달라진다. 기본은 tab
	  var basicCode = 'IIM';
	  var addQsearchParam = '';
	  var defaultParams = {
	    'q': decodeURIComponent(_globals.utf8Query),
	    'w': 'spread',
	    'qsearch_ver': 'v2',
	    'viewtype': 'json',
	    'mk': window.mk,
	    'uk': window.uk,
	    'exp': basicCode + addQsearchParam,
	    'lpp': _configs.AJAX_PAGE_PER_COUNT
	  };
	  var additionalParams = ['monochrome', 'clipart', 'lineart'];
	  _jquery2['default'].each(additionalParams, function (idx, each) {
	    if (_tab_params2['default'][each] === 'y') {
	      defaultParams[each] = 'y';
	    }
	  });
	
	  /**
	   * PC
	   * 버킷 테스트를 진행시, API에서도 버킷 결과를 받기 위해 bucket_type 파라미터 삽입.
	   * */
	  if (window.bucketType) {
	    defaultParams['bucket_type'] = window.bucketType;
	  }
	
	  return SF.getQsUrl(_jquery2['default'].extend({}, defaultParams, params), 1);
	}

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = "{{if data.length > 0}} <span class=\"txt_bar\">&nbsp;|&nbsp;</span> <span class=\"png_comm ico_ccl1\">저작권 표시</span> {{for data}} <span class=\"png_comm ico_ccl{{:icon_code}}\">{{:desc}}</span> {{/for}} {{/if}}";

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = "<p class=\"f_eb message\"> {{if endType === 'end' || endType === ''}} 다음 검색이 분석한 최적의 검색결과를 확인하셨습니다. 원하시는 결과를 못 얻으셨다면 검색어를 변경해서 다시 검색해보시기 바랍니다. {{else endType === 'dup_end'}} 효과적으로 검색결과를 확인하실 수 있도록 중복된 이미지는 생략되었습니다. 원하시는 결과를 못 얻으셨다면 검색어를 변경해서 다시 검색해보시기 바랍니다. {{/if}}</p> <a class=\"btn_top\"><span class=\"txt_top\">맨위로<span class=\"ico_rwd\"></span></span></a>";

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = "<div class=\"wrap_thumb\" style=\"{{:wrapperStyle}}\"> <a href=\"{{:linkUrl || 'javascript:;'}}\" class=\"link_thumb\"><img src=\"//:0\" data-src=\"{{:imageUrl}}\" class=\"thumb_img\" alt=\"{{:title}}\" style=\"{{:imageStyle}}\" data-size=\"{{:wrapper_width}}x{{:wrapper_height}}\" onerror=\"SF.errorImage(this)\"/></a><div class=\"info_img\"> <a href=\"javascript:;\" class=\"link_info\" title=\"{{:title}}\"><strong class=\"tit_img\">{{:htitle}}</strong></a> <span class=\"txt_info\">{{if infoHTML}} {{if infoHTML.isNumberType}} <span class=\"num_info\">{{:infoHTML.infoText}}</span> {{else}} {{:infoHTML.infoText}} {{/if}} {{/if}}</span><div class=\"info_original\"> <a href=\"{{:originalUrl}}\" class=\"btn_original\" target=\"_blank\"><span class=\"ico_rwd ico_original\">원본</span></a> {{if isReportMode}} <a href=\"javascript:;\" data-cnucc=\"IIM|{{:docid}}\" class=\"ico_rwd ico_report\" style=\"display: none\">신고</a> {{/if}}</div></div> {{if isReportMode}} <a href=\"javascript:;\" data-cnucc=\"IIM|{{:docid}}\" class=\"ico_rwd ico_report\" style=\"display: none\">신고</a> {{/if}}</div>";

/***/ },
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = initLog;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _logger = __webpack_require__(4);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function sendClickLogOnClick(eventTarget, params, e, rc) {
	  var at = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'link';
	
	  var linkElem = eventTarget.nodeName && eventTarget.nodeName === 'A' ? eventTarget : eventTarget.querySelector('a');
	  var thumbData = e.imageData;
	  var ndid64Str = thumbData.ndid64 || '';
	  var logParams = {
	    d: thumbData.docid,
	    p: params.p,
	    r: thumbData.index + 1,
	    rc: rc,
	    pg: thumbData.page,
	    e1: thumbData.info.cpid,
	    ext: 'dsid=' + thumbData.docid + '__DeLiM__ndid64=' + ndid64Str,
	    at: at
	  };
	
	  _logger2['default'].sendClickLog(linkElem, logParams, e.originalEvent, {
	    img: {
	      cpid: thumbData.info.cpid,
	      ndid64: ndid64Str
	    }
	  });
	}
	
	function onThumbClick(imageApp) {
	  imageApp.thumbBoard.$board.on('thumb:click', function (e) {
	    var rc = _jquery2['default'].map(imageApp.thumbBoard.data, function (item) {
	      return item.hide === 'Y' ? null : item;
	    }).length;
	    sendClickLogOnClick(e.targetLink, { p: 1 }, e, rc);
	  });
	}
	
	function onExtenderClick(imageApp) {
	  imageApp.btnExtend.$elem.on('click', function (e) {
	    var clickCnt = imageApp.state.moreBtnClickCnt;
	    var extendECode = 10;
	    var foldECode = 21;
	    var logParams = {
	      pg: 1,
	      rc: 1,
	      at: 'func'
	    };
	
	    logParams.e = clickCnt > 0 ? extendECode + clickCnt - 1 : foldECode;
	
	    _logger2['default'].sendClickLog(this, logParams, e);
	  });
	}
	
	function onMoreLinkButtonClick($imageColl) {
	  var $btnMore = $imageColl.find('.extend_comp .expender.more');
	  $btnMore.on('click', function (e) {
	    var logParams = {
	      e: 1,
	      rc: 1,
	      at: 'more'
	    };
	    _logger2['default'].sendClickLog(this, logParams, e);
	  });
	}
	
	function initLog($imageColl, imageApp) {
	  _logger2['default'].setBasicCode('s', 'TO');
	  onThumbClick(imageApp);
	  onExtenderClick(imageApp);
	  onMoreLinkButtonClick($imageColl);
	}

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** image/image-tot.bundle.ad03750.js
 **/